import axios from 'axios'
import  { useState } from 'react'
import { MdArrowDropDown, MdArrowRight, MdPlayArrow } from 'react-icons/md'
import { formatPipe } from '../../utils/utils'

const server = process.env.REACT_APP_SERVER_URL
const TreeItem = ({ accountingPlan, columns }) => {
  const [accountingValues, setAccountingValues] = useState([
    'code',
    'level',
    'name',
    'accountType',
    'balance',
  ])

  const [widthValues, setWidthValues] = useState({
    ELEMENT: 0,
    CLASS: 10,
    GROUP: 20,
    'SUB-GROUP': 30,
    MAJOR: 40,
    AUXILIARY: 50,
  })

  const [changeValues, setChangeValues] = useState({
    ELEMENT: 'Tipo',
    CLASS: 'Clase',
    GROUP: 'Grupo',
    'SUB-GROUP': 'Sub - Grupo',
    MAJOR: 'Mayor',
    AUXILIARY: "Auxiliar"
  })
  
  const [changeValueAccountType, setChangeValueAccountType] = useState({
    'OTHER': '',
    'CASH': 'M',
    'NON-CASH': 'NM'
  })

  const [isVisible, setIsVisible] = useState<boolean>(false)

  const [children, setChildren] = useState([])

  const onGetChildren = async (value) => {

    if (isVisible) {
      setIsVisible(false)
    } else {
      let response = await axios.get(
        `${server}/accounting?childrenOf=${value.id}`
      )
      setIsVisible(true)
      setChildren(response.data.accounts)

    }
  }

  const renderContent = (value, idx) => {
    if (idx === 2 && !accountingPlan.leaf) {
      return (
        <div
          className="flex items-center cursor-pointer"
          style={{
            width: '100%',
            paddingLeft: idx === 2 && widthValues[accountingPlan.level],
          }}
        >
          {isVisible ? (
            <MdArrowDropDown className="text-primary" size={20} />
          ) : (
            <MdArrowRight className="text-primary" size={20} />
          )}
          {+accountingPlan[value] < 0 && idx === 4 ? (
            <div className="flex">
              <h1 className="text-xs font-medium">(-)</h1>
              <h1 className={`text-xs font-medium ${idx === 1 && 'text-primary'}`}>
                {accountingPlan[value]}
              </h1>
            </div>
          ) : (
            <div className='flex'>
            <h1 className={`text-xs font-medium ${idx === 1 && 'text-primary'}`}>
              {accountingPlan[value]}
            </h1>

            {/* <h1 className={`text-xs font-medium ${idx === 1 && 'text-primary'}`}>
              NM
            </h1> */}

            </div>
          )}
        </div>
      )
    }
    if (idx === 4) {
      return (
        <div className="flex">
          <h1 className={`text-xs font-medium ${idx === 1 && 'text-primary'}`} style={{color: +accountingPlan[value] < 0 ? 'red': ''}}>
            {+accountingPlan[value] < 0 ? `(${formatPipe((+accountingPlan[value] * -1) + "")})` : formatPipe(accountingPlan[value]) }
          </h1>
        </div>
      )
    }

    if (idx === 3) {
      return (
        <h1 className='text-xs font-bold text-primary'>{changeValueAccountType[accountingPlan[value]]}</h1>
      )
    }

    return (
      <h1
        className={`text-xs font-medium ${idx === 1 && 'text-primary'}`}
        style={{
          paddingLeft: idx === 2 && widthValues[accountingPlan.level] + 20,
        }}
      >
        {idx === 1
          ? changeValues[accountingPlan[value]]
          : idx === 4 && +accountingPlan[value] < 0
          ? `(-)${+accountingPlan[value] * -1}`
          : accountingPlan[value]}
      </h1>
    )
  }

  return (
    <div>
      <div className="flex justify-between">
        {accountingValues.map((v, idx) => (
          <div
            className="mb-2"
            style={{ width: columns[idx].width }}
            onClick={() =>
              idx === 2 && !accountingPlan.leaf
                ? onGetChildren(accountingPlan)
                : null
            }
          >
            {/* <div className="flex items-center">
              {isVisible ? (
                <MdArrowDropDown className="text-primary" size={20} />
              ) : (
                <MdArrowRight className="text-primary" size={20} />
              )}
              <h1 className="text-xs">{accountingPlan[v]}</h1>
            </div> */}

            {renderContent(v, idx)}
          </div>
        ))}
      </div>
      {isVisible
        ? <div>
          {children.map((child, idx) => (
            <div className="mt-2">
              <TreeItem accountingPlan={child} columns={columns} />
            </div>
          ))}
        </div> 
        
        : ''}
    </div>
  )
}

export default TreeItem
